import { t } from "i18next";
import styles from "./ActionButton.module.css";

export const ActionButton = ({ dataCy }: { dataCy?: string }) => {
  return (
    <button data-cy={dataCy} className={styles.actionButton}>
      {t("main.actions")}
      <span className="material-icons">keyboard_arrow_right</span>
    </button>
  );
};
